import script from "./Location.vue?vue&type=script&lang=ts&setup=true"
export * from "./Location.vue?vue&type=script&lang=ts&setup=true"

import "./Location.vue?vue&type=style&index=0&id=74fd2d8e&scoped=true&lang=less"
import "./Location.vue?vue&type=style&index=1&id=74fd2d8e&lang=less"
import "./Location.vue?vue&type=style&index=2&id=74fd2d8e&lang=less"

import exportComponent from "D:\\Code\\BranchManageSystem\\UI\\risfond-branchmanagementsystem\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74fd2d8e"]])

export default __exports__